import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import { useTheme } from '@material-ui/core/styles';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { MyMeetingsContent } from './Late2023MemberNavContent';

const MyMeetingsContainer = () => {
  const [meetings, setMeetings] = useState({ loading: true, value: false });
  const [previousMeeting, setPreviousMeeting] = useState({ loading: true, value: false });
  const { householdResource } = useSimpleHousehold();
  const [displayScheduleNextMeetingButton, setDisplayScheduleNextMeetingButton] = useState(false);

  const getMeetings = () => {
    householdResource?.relationship(fr.relationships.scheduledFutureMeetings.name)
      ?.link('related').Get({ params: { tz: moment.tz.guess() } })
      .then((res) => {
        if (res) {
          const meetingList = res.resources().list();
          setMeetings({ loading: false, value: meetingList });
        }
      })
      .catch((err) => {
        setMeetings({ loading: false, value: false });
        displayErrorMessage(err, 'There was an error loading your future meetings');
      });
  };

  const getPreviousMeeting = () => {
    householdResource?.relationship(fr.relationships.previousScheduledMeeting.name)
      ?.link('related').Get({ params: { tz: moment.tz.guess() } })
      .then((res) => {
        if (res) {
          const prevMeeting = res.resources().head();
          setPreviousMeeting({ loading: false, value: prevMeeting });
        }
      })
      .catch((err) => {
        setPreviousMeeting({ loading: false, value: false });
        displayErrorMessage(err, 'There was an error loading your previous meeting');
      });
  };

  const updateDisplayScheduleNextMeetingButton = async () => {
    try {
      const [householdResourceWithTz] = await householdResource.link('self').get({
        params: {
          tz: moment.tz.guess(),
        },
      });
      if (householdResourceWithTz.relationship(fr.relationships.scheduleNewMeeting.name)) {
        setDisplayScheduleNextMeetingButton(true);
      } else {
        setDisplayScheduleNextMeetingButton(false);
      }
    } catch (err) {
      setDisplayScheduleNextMeetingButton(false);
      displayErrorMessage(err, 'There was an error loading your next meeting options.');
    }
  };

  useEffect(() => {
    if (householdResource) {
      getMeetings();
      getPreviousMeeting();
      updateDisplayScheduleNextMeetingButton();
    }
  }, [householdResource]);

  const theme = useTheme();
  useBackgroundColor(theme.palette.facet.lightGray);

  return (
    <FullScreenDataContainer
      component={MyMeetingsContent}
      componentProps={{
        householdResource,
        displayScheduleNextMeetingButton,
        meetings: meetings.value,
        previousMeeting: previousMeeting.value,
        refreshMeetings: getMeetings,
      }}
      loading={meetings.loading || previousMeeting.loading}
    />
  );
};

export default MyMeetingsContainer;
